import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { FormattedMessage, useTranslator } from '@jutro/locale'
import { DateValue } from '@jutro/components';
import classNames from 'classnames';

import metadata from './MLLegacyPolicySummaryDetailsComponent.metadata.json5';
import messages from './MLLegacyPolicySummaryDetailsComponent.messages';
import styles from './MLLegacyPolicySummaryDetailsComponent.module.scss';

const lobNames = {
    'A': 'Auto',
    'H': 'Home',
    'U': 'Umbrella',
    'Y': 'Watercraft'
};

const MLLegacyPolicySummaryDetailsComponent = (props) => {
    const { policies } = props;

    const translator = useTranslator();

    const getLOBPolicyName = (policy) => {
        return lobNames[policy.productGroupCode];
    };

    const getStatusCode = (policy) => {
        let status = '';
        switch (policy.policyStatusCode.charAt(0)) {
            case '1':
                status = 'Active';
                break;
            case '2':
                status = 'No Longer Used';
                break;
            case '3':
                status = 'Canceled';
                break;
            case '4':
                status = 'Expired';
                break;
            default:
                break;
        }
        return status;
    };

    const redirectURL = (policy) => {
        let redirectUrl = '';
        const itemNumber = policy.productGroupCode + policy.policyID + policy.policySuffixID;
        redirectUrl = policy.redirectUrl.replace('*', itemNumber);
        window.open(redirectUrl, '_blank');
    };

    const getPoliciesOverrides = () => {
        const getLobIconClassName = (policy) => {
            switch (policy.policyGroupCode) {
                case 'A': {
                    return 'icon-icon-car-white';
                }
                case 'U': {
                    return 'icon-ml-umbrella-icon';
                }
                case 'H': {
                    return 'icon-ml-home-detailed-icon';
                }
                default: {
                    break;
                }
            }
        }
        const overrides = policies.map((policy, index) => {
            return {
                [`lobIcon${index}`]: {
                    className: classNames('floatLeft', getLobIconClassName(policy))
                },
                [`generalInfoContainer${index}`]: {
                    className: classNames('floatLeft', policy.productGroupCode === 'Y' ? 'margin-left-50' : undefined)
                },
                [`policyHeader${index}`]: {
                    content: translator(messages.policy, {lob: getLOBPolicyName(policy)})
                },
                [`policyNumber${index}`]: {
                    content: translator(messages.policyNumber, {number: policy.policyID})
                },
                [`insuredFullName${index}`]: {
                    content: policy.insured.fullName
                },
                [`addressDetails${index}`]: {
                    content: (
                        <span>
                            {_.get(policy, 'insured.address.addressLine1')}
                            <br />
                            {_.get(policy, 'insured.address.city')}, {_.get(policy, 'governingRegionShortName')} {_.get(policy, 'insured.address.postalCode')}
                        </span>
                    )
                },
                [`insuredPhone${index}`]: {
                    content: policy.insured.phone
                },
                [`viewPolicyButton${index}`]: {
                    onClick: () => redirectURL(policy)
                },
                [`policyStatus${index}`]: {
                    content: `${translator(messages.status)} ${getStatusCode(policy)}`
                },
                [`policyEffectiveDate${index}`]: {
                    content: (
                        <FormattedMessage
                            {...messages.effectiveDate}
                            values={{
                                date: <DateValue displayFormat='vshort' value={policy.policyEffectiveDate} />
                            }}
                        />
                    )
                },
                [`policyExpirationDate${index}`]: {
                    content: (
                        <FormattedMessage
                            {...messages.expirationDate}
                            values={{
                                date: <DateValue displayFormat='vshort' value={policy.policyExpirationDate} />
                            }}
                        />
                    )
                }
            };
        });

        return Object.assign({}, ...overrides);
    }

    const overrideProps = {
        ...getPoliciesOverrides(),
        policiesIterable: {
            data: policies
        }
    }

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
        />    
    )
};

MLLegacyPolicySummaryDetailsComponent.propTypes = {
    policies: PropTypes.arrayOf(PropTypes.shape({}))
};

MLLegacyPolicySummaryDetailsComponent.defaultProps = {
    policies: [],
};

export default MLLegacyPolicySummaryDetailsComponent;